import { Grid } from '@material-ui/core';
import { Field } from 'formik';
import React, { Fragment } from 'react';
import createShowIf from 'v2/components/Shared/createShowIf';
import { SwitchFormField } from 'v2/components/Shared/FormFields/SwitchFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';

import type { IForm } from 'v2/components/Shared/Content';

import type { Checkout as CheckoutClass } from '../../classes/Payment';

interface IProps extends IForm<CheckoutClass> {}

const Checkout = ({ values, setFocus }: IProps) => {
  const ShowIfCheckout = createShowIf<CheckoutClass>();

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Field id='allows_boleto' name='allows_boleto' label='Permitir boleto' component={SwitchFormField} />
        </Grid>
        <ShowIfCheckout value={values} compare={{ eq: { allows_boleto: true } }}>
          <Grid item xs={12}>
            <Field
              label='Url obrigado para boleto'
              name='url_thankyou_boleto'
              id='url_thankyou_boleto'
              onFocus={setFocus}
              component={TextFormField}
            />
          </Grid>
        </ShowIfCheckout>
        <Grid item xs={12}>
          <Field id='allows_card' name='allows_card' label='Permitir cartão' disabled={values.allows_card} component={SwitchFormField} />
        </Grid>
        <ShowIfCheckout value={values} compare={{ eq: { allows_card: true } }}>
          <Grid item xs={12}>
            <Field
              label='Url obrigado para cartão e PIX'
              name='url_thankyou_card'
              id='url_thankyou_card'
              onFocus={setFocus}
              component={TextFormField}
            />
          </Grid>
        </ShowIfCheckout>
        <Grid item xs={12}>
          <Field id='allows_multiple_cards' name='allows_multiple_cards' label='Permitir múltiplos cartões' component={SwitchFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field id='document_on_checkout' name='document_on_checkout' label='CPF/CNPJ pagador' component={SwitchFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field
            id='ask_address_checkout'
            name='ask_address_checkout'
            label='Pedir endereço no checkout'
            checked={values.ask_address_thanks ? false : values.ask_address_checkout}
            disabled={values.ask_address_thanks}
            component={SwitchFormField}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            id='ask_address_thanks'
            name='ask_address_thanks'
            label='Pedir endereço no pós compra'
            checked={values.ask_address_checkout ? false : values.ask_address_thanks}
            disabled={values.ask_address_checkout}
            component={SwitchFormField}
          />
        </Grid>
        <Grid item xs={12}>
          <Field id='hide_quantity' name='hide_quantity' label='Ocultar quantidade' component={SwitchFormField} />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Checkout;
